// SeriesAudience.tsx — (B117; planning 10-25 19:10) "The audience" of a series: an audience profile (Admin → Audiences) that
// every pilot and episode order of the series carries as its audiencePersonaId. Used by New series and the series' page.
import type { ProfileRow } from "@/api/audiences.ts";
import { audienceOptionLabel } from "@/lib/series.ts";

// (audit 10-27) profiles null: not read yet (or the read failed), so a chosen audience isn't called "no longer a profile"
export function SeriesAudienceSelect({ value, onChange, profiles, style }: {
  value: string; onChange: (id: string) => void; profiles: ProfileRow[] | null; style?: React.CSSProperties;
}) {
  const known = (profiles ?? []).some((p) => p.id === value);
  return (
    <select style={style} value={value} onChange={(e) => onChange(e.target.value)} aria-label="The audience">
      <option value="">None (its orders are refused)</option>
      {value && !known && <option value={value}>{profiles === null ? value : `${value} (no longer a profile)`}</option>}
      {(profiles ?? []).map((p) => <option key={p.id} value={p.id}>{audienceOptionLabel(p)}</option>)}
    </select>
  );
}
